import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import {BsFillClockFill} from "react-icons/bs";
import styled from "styled-components";

const StyledTimePicker = styled(TimePicker)`
  width: 100%;
  &.error {
    border: 1px solid red;
  }

  svg {
    position: absolute;
    right: 5px;
    top: 9px;
  }

  .rc-time-picker-clear {
    display: none;
  }
  
  
  .rc-time-picker-input{
    color: black;
    font-size: 14px;
    height: 32px
  }
  
  .rc-time-picker-input:hover {
    border: 1px solid #40a9ff;
  }
  
`;

const DG_Time_Piker = (props)=>{

    return (
        <StyledTimePicker
            minuteStep={1}
            showSecond={false}
            use12Hours={false}
            allowEmpty={false}
            inputIcon={<BsFillClockFill className={"mt-[7px]"}/>}
            value={props.value}
            onChange={props.onChange}
            focusOnOpen
        />
    )
}

export default DG_Time_Piker
